
<div class="iframe-container">
  <iframe class="responsive-iframe" [src]="iframeUrl" frameborder="0"
    sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>
</div>